module.exports = __webpack_public_path__ + "static/media/27OCHA11.d0b00050.jpg";